import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { firebaseConfig } from "../config/firebase";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let analytics = null;
if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Firebase Analytics not available.", e);
  }
}

let messaging = null;
if ("serviceWorker" in navigator && "PushManager" in window) {
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.warn("Push messaging is not supported in this browser.", e);
  }
}

export { app, auth, analytics, messaging, firebaseConfig };
